<template>
  <div class="product warp">
    <div class="main">
      <div class="table">
        <el-table
          :data="tableData"
          v-loading="loading"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="amount"
            :formatter="payFormat"
            align="center"
            label="提现金额"
          >
          </el-table-column>
          <el-table-column align="center" label="申请时间">
            <template slot-scope="scope">
              {{ getRQ(scope.row.applicant_time) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="withdrawals_sn"
            label="账单单号"
          >
          </el-table-column>
          <el-table-column align="center" prop="type" label="收款方式">
            <template slot-scope="scope">
              {{ scope.row.type == 1 ? "微信" : "支付宝" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="withdrawals_account"
            label="收款账号"
          >
          </el-table-column>
          <el-table-column align="center" prop="status" label="审核状态">
            <template slot-scope="scope">
              <span :class="scope.row.status == 2 ? 'green' : 'red'" >
                {{
                scope.row.status == 1
                  ? "未审核"
                  : scope.row.status == 2
                  ? "审核通过"
                  : "审核未通过，"
              }}
              <el-link
                type="primary"
                @click="remarks(scope.row.withdrawals_sn)"
                v-if="scope.row.status == 3"
                >查看原因</el-link
              >
              </span>
              
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            @size-change="sizeChange"
            @current-change="handleSizeChange"
            :current-page="page"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="原因" width="30%" :visible.sync="dialogFormVisible">
      <ul class="reson">
        <li><span>提现金额：</span>{{ table.amount | payFormat }}</li>
        <li><span>提现时间：</span>{{ getRQ(table.applicant_time)}}</li>
        <li>
          <span>收款方式：</span>{{ table.type == "1" ? "微信" : "支付宝" }}
        </li>
        <li><span>收款账号：</span>{{ table.withdrawals_account }}</li>
        <li><span>真实姓名：</span>{{table.withdrawals_account_name}}</li>
        <li>
          <span>审核状态：</span
          >{{
            table.status == 1
              ? "未审核"
              : table.status == 2
              ? "审核通过"
              : "审核未通过"
          }}
        </li>
        <li>
          <span style="padding-right: 2em">原因</span>：
          <p>{{ table.remarks }}</p>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" plain>关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
// import datails from './components/details.vue'

import help from "@/assets/js/common.js";
export default {
  name: "product",
  data() {
    return {
      tableData: [],
      table: {},
      dialogFormVisible: false,
      loading: true,
      total: 0,
      limit: 8,
      page: 1,
      formsdatas: 0,
      ordersNumber: "",
      phone: "",
      page_size: null,
      withdrawable: 0,
    };
  },
  props: {},
  filters: {
    payFormat(val) {
      return Number(val).toFixed(2);
    }
  },
  components: {
    // datails
  },
  mounted() {},
  computed: {
    ...mapGetters(["getToken"]),
    ...mapGetters(["getTotalAmount"]),
    ...mapGetters(["getWithdrawableCash"]),
    ...mapGetters(["getPageSize"]),
  },
  created() {
    // this.Bind(0);
    if (this.page_size == null) {
      this.page_size = this.getPageSize;
    }
    this.refreshList();
    if (this.getWithdrawableCash != 0 || this.getWithdrawableCash != null) {
      this.withdrawable = this.getWithdrawableCash;
    }
  },
  methods: {
    ...mapActions({
      getLogsList: "loginModule/getLogsList",
    }),
    ...mapMutations({
      setTotalAmount: "setTotalAmount", //设置用户信息
      setWithdrawableCash: "setWithdrawableCash", //设置用户信息
      setPageSize: "setPageSize", //设置用户信息
    }),
    remarks(val) {
      // console.log(val);
      this.tableData.forEach((item) => {
        if (item.withdrawals_sn == val) {
          this.table = item;
        }
      });
      this.dialogFormVisible = true;
    },
    refreshList() {
      let opt = {
        token: this.getToken,
        page_size: this.page_size,
        page: this.page,
      };
      this.getLogsList(opt)
        .then((res) => {
          // console.log(res);
          if (res.data.code === 1) {
            this.tableData = res.data.data.list;
            this.total = Number(res.data.data.count);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    payFormat(row) {
      return Number(row.amount).toFixed(2);
    },
    sizeChange(val) {
      this.page_size = val;
      this.setPageSize(val);
      this.refreshList();
    },
    getRQ(val) {
      return help.getRQ(val);
    },
    handleSizeChange(val) {
      this.page = val;
      this.refreshList();
    },
  },
};
</script>
<style lang='scss' scoped>
.reson {
  width: 80%;
  margin: 0 auto;
  li {
    font-size: 14px;
    list-style: none;
    margin-top: 10px;
    display: flex;
    span {
      display: inline-block;
      white-space: nowrap;
    }
  }
}
::v-deep .el-date-editor .el-range-separator {
  padding: 0;
}
.product {
  .main {
    .table {
      margin-top: 20px;
      .page {
        margin-top: 20px;
        float: right;
      }
    }
  }
}

.red{
color:#d05454;
}

.green{
  color: #094;
}

</style>